<div class="map-height">
  <div class="toggleMode map-toggle-buttons flex flex-column mb-3">
    <p-toggleButton id="toggle_button" class="p-0 mb-2"
      offIcon="pi pi-moon" onIcon="pi pi-sun"
      (onChange)="toggleDarkAndLightMap($event)" [(ngModel)]="checked"></p-toggleButton>
  </div>
  <div class="col-12 md:col-11 lg:col-11 map-filters">
    <div class="grid">
      <div class="col-12 md:col-4 lg:col-2 width300 py-0">
        <div class="form-control form-field filter-drop-down">
          <label id="searchInput" title="Search" class="fa fa-search search-icon"></label>
          <input id="searchPlaceHolder" type="text" class="grid-search-bar top pl-4"
            [(ngModel)]="searchDriverInMap" (keyup.enter)="searchDrivers()"
            [placeholder]="searchPlaceHolder" />
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-2 width150 py-0">
        <div class="form-control filter-drop-down">
          <p-dropdown id="currentStatus" [options]="currentStatus" [(ngModel)]="selectedCurrentStatus"
            (onChange)="changeFilter('driverCurrentStatus', selectedCurrentStatus)"
            [placeholder]="'label_current_status' | translate">
          </p-dropdown>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-2 width200 py-0">
        <div class="form-control filter-drop-down">
          <p-dropdown id="parkingLocationsOptions" [options]="parkingLocationsOptions"
            [(ngModel)]="defaultSelectedparkingLocation"
            (onChange)="changeFilter('parkingLocationId', defaultSelectedparkingLocation)"
            [placeholder]="'label_parking_location' | translate">
          </p-dropdown>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-2 width150 py-0">
        <div class="form-control filter-drop-down">
          <p-dropdown id="sortTypeOptions" [options]="sortTypeOptions" [(ngModel)]="selectedSortType"
            (onChange)="changeFilter('sortBy', selectedSortType)"
            [placeholder]="'label_sort_by' | translate">
          </p-dropdown>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-2 width150 py-0">
        <div class="form-control filter-drop-down">
          <p-dropdown id="teamsOptions" [options]="teamsOptions" [(ngModel)]="selectedTeam"
            (onChange)="changeFilter('shiftId', selectedTeam)" [placeholder]="'label_team' | translate">
          </p-dropdown>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-2 width150 py-0">
        <div class="form-control filter-drop-down">
          <p-dropdown id="radiusOption" [options]="radiusOption" [(ngModel)]="selectedRadius"
            (onChange)="changeFilter('radiusToPickup', selectedRadius)"
            [placeholder]="'label_radius_to_pickup' | translate">
          </p-dropdown>
        </div>
      </div>
      <div class="col-fixed py-0">
        <button id="label_apply"
          [ngClass]="filterApplied ? 'filter-btn-apply filter-applied' : 'filter-btn-apply'" pButton appRipple
          (click)="applyFilter()" type="button" icon="fa fa-check"
          [label]="'label_apply' | translate"></button>
        <button id="label_reset" pButton appRipple class="reset-btn" (click)="resetFilter()" type="button"
          icon="fa fa-undo" [label]="'label_reset' | translate"></button>
      </div>
    </div>
  </div>
  <div id="driver-map" class="map"></div>
</div>
